<div class="flex flex-col gap-1">
  @if (!IsNullOrUndefinedOrEmpty(label())) {
    <immo-form-field-label
      [label]="label()"
      [for]="fieldId()"
      [required]="required()"
      [hasError]="showError()"
    />
  }

  <div
    ngCombobox
    #combobox="ngCombobox"
    class="entity-select__trigger flex items-center justify-between gap-2 px-3 py-2"
    [id]="fieldId()"
    [(expanded)]="expanded"
    [preserveContent]="true"
    [disabled]="disabled()"
    [class.entity-select__trigger--disabled]="disabled()"
    [class.entity-select__trigger--error]="showError()"
    [attr.data-test-id]="testId()"
    [attr.data-variant]="variant()"
  >
    @if (!IsNullOrUndefined(triggerTemplate()) && !IsNullOrUndefined(value())) {
      <ng-container *ngTemplateOutlet="triggerTemplate()!; context: { $implicit: value() }" />
    } @else {
      <span
        class="entity-select__trigger-label truncate"
        [class.entity-select__trigger-label--placeholder]="IsNullOrUndefinedOrEmpty(triggerLabel())"
      >
        {{ IsNullOrUndefinedOrEmpty(triggerLabel()) ? placeholder() : triggerLabel() }}
      </span>
    }

    <mat-icon class="entity-select__arrow" aria-hidden="true">arrow_drop_down</mat-icon>
  </div>

  <div aria-live="polite" class="cdk-visually-hidden">
    {{ items().length === 0 && !isLoading() ? notFoundText() : '' }}
  </div>

  <ng-template
    [cdkConnectedOverlay]="{ origin: combobox.element, usePopover: 'inline', matchWidth: true }"
    [cdkConnectedOverlayOpen]="expanded()"
    (overlayOutsideClick)="close(false)"
  >
    <ng-template ngComboboxPopup [combobox]="combobox" popupType="dialog">
      <div
        ngComboboxWidget
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
        class="entity-select__panel mt-2"
        [attr.data-variant]="variant()"
        (keydown)="onPanelKeydown($event)"
      >
        @if (!IsNullOrUndefinedOrEmpty(panelLabel())) {
          <div class="entity-select__panel-label px-4 pt-4">
            {{ panelLabel() }} · {{ items().length }}
          </div>
        }

        <div class="entity-select__search flex items-center gap-2 px-4 py-3">
          <mat-icon aria-hidden="true">search</mat-icon>
          <input
            #searchInput
            type="text"
            class="entity-select__search-input w-full"
            [placeholder]="placeholder()"
            [attr.aria-label]="placeholder()"
            [value]="query()"
            (input)="query.set(searchInput.value)"
            (keydown.arrowdown)="focusListbox($event)"
            (keydown.arrowup)="focusListbox($event)"
            (keydown.enter)="$event.preventDefault()"
          />
        </div>

        @if (isLoading()) {
          <div class="entity-select__state flex justify-center px-4 py-6">
            <mat-spinner [diameter]="24" />
          </div>
        } @else if (items().length === 0 && !IsNullOrUndefinedOrEmpty(notFoundText())) {
          <div class="entity-select__state px-4 py-6">{{ notFoundText() }}</div>
        }

        <div
          #listboxElement
          ngListbox
          class="entity-select__listbox flex flex-col gap-1 p-2 overflow-auto"
          focusMode="activedescendant"
          selectionMode="explicit"
          [tabindex]="-1"
          [(value)]="selectedValues"
          (click)="commit()"
          (keydown.enter)="commit()"
        >
          @for (option of items(); track option) {
            <div
              ngOption
              class="entity-select__option flex items-center gap-3 px-3 py-2"
              [id]="getOptionDomId($index)"
              [value]="option"
              [label]="getOptionLabel(option)"
            >
              @if (!IsNullOrUndefined(rowTemplate())) {
                <ng-container
                  *ngTemplateOutlet="
                    rowTemplate()!;
                    context: {
                      $implicit: option,
                      selected: isSelected(option),
                      active: isActive($index),
                    }
                  "
                />
              } @else {
                <span class="flex flex-col min-w-0">
                  <span class="entity-select__option-label truncate">{{
                    getOptionLabel(option)
                  }}</span>

                  @if (!IsNullOrUndefinedOrEmpty(getOptionSubLabel(option))) {
                    <span class="entity-select__option-sub-label truncate">{{
                      getOptionSubLabel(option)
                    }}</span>
                  }
                </span>
              }
            </div>
          }
        </div>
      </div>
    </ng-template>
  </ng-template>

  <!-- ERRORS -->
  @if (showError()) {
    <ng-container ngProjectAs="mat-error">
      <mat-error
        animate.enter="form-error"
        animate.leave="collapse-vertical"
        class="text-body-sm tracking-body-sm leading-body-sm"
      >
        <immo-form-field-error [state]="state()" [displayName]="displayName()" />
      </mat-error>
    </ng-container>
  }
  <!-- /errors -->
</div>
